import './styles.scss';

/**
 * AnimatedText component renders a string by splitting it into individual characters,
 * allowing each character to be animated separately.
 *
 * @param {string} text — The text to display. It will be split into characters.
 * @param {string} [className] — Optional additional CSS class for the root element.
 */

export default function AnimatedText({ text, className }) {
    return (
        <span className={`animated-text ${className || ''}`} aria-label={text}>
            {text?.split('').map((char, i) => (
                <span key={i} className='animated-text_char'>
                    {char === ' ' ? '\u00A0' : char}
                </span>
            ))}
        </span>
    );
}
